import { Navigate } from "react-router-dom";

import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { AttendanceApproval, ContentAttendanceApproval } from "./pages";

const presenceApprovalRoutes = [
  {
    path: "/presence",
    element: (
      <ProtectedRoute name="presence_approval">
        <Navigate to="presence-approval/waiting-approval" replace />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="presence"
        defaultTitle="breadcrumb.presence"
      />
    ),
  },
  {
    path: "/presence/presence-approval",
    element: (
      <ProtectedRoute name="presence_approval">
        <AttendanceApproval />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="presence_approval"
        defaultTitle="attendanceApproval.title"
      />
    ),
    children: [
      {
        path: "/presence/presence-approval/waiting-approval",
        element: <ContentAttendanceApproval type="waiting-approval" />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"approval.waiting_approval"} />
        ),
      },
      {
        path: "/presence/presence-approval/approved",
        element: <ContentAttendanceApproval type="approved" />,
        breadcrumb: () => <TranslationBreadcrumb name={"approval.approved"} />,
      },
      {
        path: "/presence/presence-approval/rejected",
        element: <ContentAttendanceApproval type="rejected" />,
        breadcrumb: () => <TranslationBreadcrumb name={"approval.rejected"} />,
      },
    ],
  },
];

export default presenceApprovalRoutes;
